import React, { Component } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import './WhyBooklyChoice.css';
import feature1 from "../assets/WhyBookly/feature-1-bedroom.png";
import feature2 from "../assets/WhyBookly/feature-2-support.png";
import feature3 from "../assets/WhyBookly/feature-3-app.png";
import feature4 from "../assets/WhyBookly/feature-4-earn.png";

class WhyBooklyChoice extends Component {
  render() {
    return (
      <section className="why-bookly-section py-5">
        <div className="container py-4">
          
          {/* Section Header */}
          <div className="text-center mb-5 pb-3">
            <h2 className="why-title fw-bold mb-1">Why Bookly is Your Ultimate</h2>
            <div className="why-subtitle-wrapper d-inline-block position-relative">
              <span className="why-script-text">best choice?</span>
              {/* Hand-drawn style SVG underline */}
              <svg className="why-underline" viewBox="0 0 160 20" xmlns="http://www.w3.org/2000/svg">
                <path d="M5,12 Q80,2 155,14" fill="none" stroke="#0047CC" strokeWidth="3.5" strokeLinecap="round"/>
              </svg>
            </div>
          </div>

          {/* Feature Rows (Alternating Zig-Zag Layout) */}
          <div className="features-container d-flex flex-column gap-5">
            
            {/* Row 1: Text Left, Image Right */}
            <div className="row align-items-center g-5">
              <div className="col-lg-6">
                <div className="feature-content-box pe-lg-4">
                  <div className="number-badge mb-3">01</div>
                  <h3 className="feature-title fw-bold mb-3">Reliable Stays Across Bangladesh</h3>
                  <p className="feature-desc text-muted mb-0">
                    From cozy rooms to furnished apartments, find short-term stays in Dhaka, Chattogram, Cox's Bazar, Sylhet, and more, with real-time support and verified listings.
                  </p>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="feature-image-wrapper">
                  <img 
                    src={feature1} 
                    alt="Reliable Stays" 
                    className="img-fluid rounded-4 shadow-sm w-100 object-fit-cover"
                    style={{ height: '340px' }}
                  />
                </div>
              </div>
            </div>

            {/* Row 2: Image Left, Text Right */}
            <div className="row align-items-center g-5 flex-lg-row-reverse">
              <div className="col-lg-6">
                <div className="feature-content-box ps-lg-4">
                  <div className="number-badge mb-3">02</div>
                  <h3 className="feature-title fw-bold mb-3">Strong Community Support System</h3>
                  <p className="feature-desc text-muted mb-0">
                    Whether you're a host or a guest, our local team is just a call or message away – 24 hours × 7 days a week. Real help, real people, every time.
                  </p>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="feature-image-wrapper">
                  <img 
                    src={feature2} 
                    alt="Community Support" 
                    className="img-fluid rounded-4 shadow-sm w-100 object-fit-cover"
                    style={{ height: '340px' }}
                  />
                </div>
              </div>
            </div>

            {/* Row 3: Text Left, Image Right */}
            <div className="row align-items-center g-5">
              <div className="col-lg-6">
                <div className="feature-content-box pe-lg-4">
                  <div className="number-badge mb-3">03</div>
                  <h3 className="feature-title fw-bold mb-3">Easy to Use App for Booking & Hosting</h3>
                  <p className="feature-desc text-muted mb-0">
                    Search, book, list, or manage all through one simple app. Bookly makes travel and hosting seamless for everyone.
                  </p>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="feature-image-wrapper">
                  <img 
                    src={feature3} 
                    alt="Easy to Use App" 
                    className="img-fluid rounded-4 shadow-sm w-100 object-fit-cover"
                    style={{ height: '340px' }}
                  />
                </div>
              </div>
            </div>

            {/* Row 4: Image Left, Text Right */}
            <div className="row align-items-center g-5 flex-lg-row-reverse">
              <div className="col-lg-6">
                <div className="feature-content-box ps-lg-4">
                  <div className="number-badge mb-3">04</div>
                  <h3 className="feature-title fw-bold mb-3">Earn or Save More, Without Extra Hassle</h3>
                  <p className="feature-desc text-muted mb-0">
                    Guests get quality stays at competitive rates. Hosts enjoy personalized support and faster bookings – no need to chase or guess.
                  </p>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="feature-image-wrapper">
                  <img 
                    src={feature4} 
                    alt="Earn or Save More" 
                    className="img-fluid rounded-4 shadow-sm w-100 object-fit-cover"
                    style={{ height: '340px' }}
                  />
                </div>
              </div>
            </div>

          </div>

        </div>
      </section>
    );
  }
}

export default WhyBooklyChoice;